var exports = {
  "GW": "alertMessage__9qGV6M",
  "oG": "trailingTextSansFeatures__h0V0cZ",
  "vR": "tabs__Wqm1K2",
  "OP": "fullWidthTabsPanel__sodmOE",
};

module.exports = exports;
